module.exports = {"pathContext":{"name":"AnalyticsFieldModifier","kind":"INPUT_OBJECT","type":"OBJECT","fields":[{"defaultValue":null,"description":null,"name":"field","type":{"kind":"ENUM","name":"AnalyticsField","ofType":null}},{"defaultValue":null,"description":null,"name":"modifiers","type":{"kind":"LIST","name":null,"ofType":{"kind":"SCALAR","name":"String","ofType":null}}}],"description":null,"enumValues":null,"possibleTypes":null}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/input-object-analytics-field-modifier.json
// module id = 1345
// module chunks = 78207197725749